import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SITE } from "../lib/site";
import { useContent } from "../lib/content";

const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/entreprise", label: "L'Entreprise" },
  { to: "/metiers", label: "Nos Métiers" },
  { to: "/realisations", label: "Réalisations" },
];

const slugify = (s) =>
  s
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z]/g, "");

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const g = useContent("global_cta");
  const contactLabel = g.header_contact || "Nous contacter";

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-gray-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-24 lg:h-28 flex items-center justify-between">
        <Link to="/" data-testid="header-logo-link" className="flex items-center group">
          <img
            src={SITE.logo}
            alt="Eco-Gest Patrimoine"
            className="h-16 lg:h-20 w-auto object-contain transition-transform duration-500 group-hover:scale-[1.03]"
          />
          <span className="sr-only">{SITE.name}</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-link-${slugify(item.label)}`}
              className={({ isActive }) =>
                `nav-link text-sm font-medium tracking-wide uppercase ${
                  isActive ? "text-[#2F3136] active" : "text-[#2F3136]/70 hover:text-[#2F3136]"
                }`
              }
              end={item.to === "/"}
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="header-cta-contact"
            className="ml-2 inline-flex items-center bg-[#E60000] hover:bg-[#B30000] text-white text-sm font-semibold tracking-wide uppercase px-6 py-3 transition-colors"
          >
            {contactLabel}
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 -mr-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" strokeWidth={1.5} /> : <Menu className="w-6 h-6" strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-gray-200 bg-white"
        >
          <nav className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-5">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`mobile-nav-${slugify(item.label)}`}
                className={({ isActive }) =>
                  `text-base font-medium tracking-wide uppercase ${
                    isActive ? "text-[#E60000]" : "text-[#2F3136]"
                  }`
                }
                end={item.to === "/"}
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-cta-contact"
              className="mt-2 inline-flex items-center justify-center bg-[#E60000] hover:bg-[#B30000] text-white text-sm font-semibold tracking-wide uppercase px-5 py-3 transition-colors"
            >
              {contactLabel}
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
